import { bridgeAtom, store } from '@/store';

import { getProductIdType } from '@/utils';

import { getCookie } from '@/modules/common';
import { EventType } from '@/modules/models';

import * as HttpClient from './api.HttpClient';
import { getUid, isTestUser } from './data';
import * as types from './types';

export const getShopifyCart = () => HttpClient.getShopifyCart();

export const getCartToken = async () => {
  try {
    const cookieToken = getCookie('cart');

    if (cookieToken?.length) {
      return cookieToken;
    }

    const cart = await getShopifyCart();

    return cart?.token || '';
  } catch (_e) {
    return '';
  }
};

export const getSessionData = async (): Promise<types.SessionData> => {
  const uid = getUid();
  const isTest = isTestUser();

  const token = await getCartToken();
  const { countryCode = '', localization = '', location = null } = store.get(bridgeAtom);

  return {
    uid,
    token,
    isTestUser: isTest,
    userAgent: window.navigator.userAgent,
    customerId: window.loggedUserId ?? null,
    countryCode,
    localization,
    location,
  };
};

interface AddShopifyEventProps {
  type: EventType;
  handle: string;
  quantity: number;
  userSession: types.SessionData;
  variantId?: string | null;
}

export const addShopifyEvent = async ({ userSession, type, handle, quantity, variantId }: AddShopifyEventProps) => {
  await HttpClient.addShopifyEvent({
    userSession,
    type,
    metadata: {
      variantId,
      quantity,
      productId: handle,
    },
  });
};

type AddEventProps = {
  type: EventType;
  userSession: types.SessionData;
  metadata: Record<string, any>;
};

export const addEvent = async ({ userSession, type, metadata }: AddEventProps) => {
  await HttpClient.addEvent({
    userSession,
    type,
    metadata,
  });
};

export const addProductToCart = async (
  handle: string,
  variantId: string,
  quantity: number,
  userSession: types.SessionData,
  params?: { [key: string]: any }
) => {
  if (!handle) {
    // TODO: add error handling
    return;
  }

  const product = await HttpClient.addProductToCart({
    handle,
    variantId,
    quantity,
    params,
  });
  await addShopifyEvent({
    userSession,
    type: EventType.ADD_TO_CART_FROM_CHAT,
    handle,
    quantity,
  });
  return product;
};

export const getToken = HttpClient.getToken;
export const chatRate = HttpClient.chatRate;

export const messages = (params: ConvertKeysToCamelCase<types.MessagesType>) => {
  return HttpClient.messages({
    ...params,
    page_type: params.pageType,
    product_id: params.productId,
    variant_id: params.variantId,
  });
};

export const openChat = HttpClient.openChat;

export const viewHistory = async (params: types.ViewHistoryType) => {
  const { productId, pageType, abGroup, abTestName, mlAbGroup, mlAbTestName } = params;

  const { product_id: id, pageType: type } = getProductIdType({
    product_id: productId,
    pageType,
  });

  await HttpClient.viewHistory({
    productId: id,
    pageType: type,
    abGroup,
    abTestName,
    mlAbGroup,
    mlAbTestName,
  });
};

export const updateSessionShopify = async (shopifySession?: types.SessionData | null) => {
  if (!shopifySession) {
    shopifySession = await getSessionData();
  }

  await HttpClient.updateSessionShopify(shopifySession);
};
